<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.house_resistance_structure, 'Structură de rezistență')"
      :items="resistanceStructures"
      item-title="name"
      item-value="id"
      name="resistance_structure"
      :loading="loading"
      :disabled="loading"
      v-model="selectedResistanceStructure"
      :rules="[v => !!v || translation(translationList.required, 'Acest câmp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useHouseStore } from '~/plugins/store/house';
import { useTranslationStore, translation } from '~/plugins/store/translations';
import type { ResistanceStructure } from '~/types/House';
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => ResistanceStructure | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-house-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const houseStore = useHouseStore();
    const translationStore = useTranslationStore();
    const selectedResistanceStructure = ref(modelValue.value ? modelValue.value : null);
    const resistanceStructures = ref<ResistanceStructure[]>([]);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref<string[]>([]);

    onMounted(async () => {
      loading.value = true;
      resistanceStructures.value = await houseStore.getResistanceStructureList();
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      loading.value = false;
      const isValid = !!selectedResistanceStructure.value;
      emit('validation-house-status', { field: 'resistance_structure', isValid });

      // Listen for validate event
      window.addEventListener('validate-house', (data) => {
        if (data.detail && data.detail === 'resistance_structure') {
          if (!selectedResistanceStructure.value) {
            error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
          } else {
            error.value = [];
            emit('validation-house-status', { field: 'resistance_structure', isValid: true });
          }
        }
      });
    });

    watch(selectedResistanceStructure, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      error.value = [];
      if (newValue && (newValue.id !== selectedResistanceStructure.value?.id)) {
        selectedResistanceStructure.value = newValue;
      }
      const isValid = !!newValue;
      emit('validation-house-status', { field: 'resistance_structure', isValid });
    });

    return {
      selectedResistanceStructure,
      translationList,
      translation,
      resistanceStructures,
      loading,
      error,
    };
  },
});
</script>